import { createFileRoute } from '@tanstack/react-router';
import { JourneysSegmentImportHandoff } from '@/pages/workspaces/imports/routing';
import { AppBundle } from '@/utils/app-bundles';
import { LastWorkspaceResolver } from './-components';

/** A segment import's upload step, which forwards to the imports wizard while the flag is on. */
function JourneysSegmentImportSetupRoute() {
  const { segmentId, importId } = Route.useParams();

  return (
    <LastWorkspaceResolver appBundle={AppBundle.Journeys}>
      <JourneysSegmentImportHandoff segmentId={segmentId} importId={importId} step="setup" />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/journeys/segments/$segmentId/imports/csv/setup/$importId/',
)({
  component: JourneysSegmentImportSetupRoute,
});
